import { Card, CardContent, Grid, IconButton, Typography } from "@mui/material";
import { ReceiptOutlined } from "@mui/icons-material";
import React from "react";
import orderIcon from "../../assets/images/order-icon.jpg";
const OrderCard = ({ title, count }) => {
  return (
    <Grid item xs={12} md={2.4}>
      <Card
        sx={{
          boxShadow: 5,
          borderRadius: "14px",
          backgroundColor: "#FFFFFF",
          width: "230px",
          height: "125px",
          borderRight: "5px solid #683C8C",
          borderBottom: "2px solid #683C8C",
          borderLeft: "1px solid #683C8C",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "40px 15px",
        }}
      >
        <IconButton
          variant="outlined"
          sx={{ height:"50px", width:"50px", border: "1px solid #000000", color: "#000000" }}
        >
          {/* <ReceiptOutlined /> */}
          <img src={orderIcon} alt="" />
        </IconButton>
        <CardContent>
          <Typography
            sx={{ fontSize: "16px", fontWeight: 400, color: "#000000"  }}
            variant="subtitle"
          >
            {title}
          </Typography>
          <Typography
            sx={{ fontSize: "32px", mt:"20px", fontWeight: 700, textAlign: "center" ,color: "#000000" }}
            variant="h3"
          >
            {count}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default OrderCard;
